import { Component, Input, inject } from '@angular/core';
import { Router } from '@angular/router';
import { SessionStorageService } from '../../../services/session-storage.service';
import { statusKey } from '../../../lib/shared-value-keys';
import { PostTradeService } from '../../post-trade.service';

@Component({
    selector: 'app-open-records-table',
    templateUrl: './open-records-table.component.html',
    styleUrls: ['./open-records-table.component.scss'],
    standalone: false
})
export class OpenRecordsTableComponent {
  private ptSvc = inject(PostTradeService);
  private route = inject(Router);
  ss = inject(SessionStorageService);

  @Input() gridSummaryRes;
  @Input() navLink: string;
  @Input() relatedGridName: string;
  @Input() statusFilter: string;

  scoreClasses = [
    {
      color: 'Red',
      varName: 'NegativeCount',
      icon: 'remove_circle',
    },
    {
      color: 'Yellow',
      varName: 'NeutralCount',
      icon: 'error',
    },
    {
      color: 'Green',
      varName: 'PositiveCount',
      icon: 'check_circle',
    },
  ];
  approvalStatuses = [
    {
      label: 'Pending',
      varName: 'Pending',
      NegativeCount: 0,
      NeutralCount: 0,
      PositiveCount: 0,
    },
    {
      label: 'In Process',
      varName: 'InProgress',
      NegativeCount: 0,
      NeutralCount: 0,
      PositiveCount: 0,
    },
    {
      label: 'Reopened',
      varName: 'Reopened',
      NegativeCount: 0,
      NeutralCount: 0,
      PositiveCount: 0,
    },
  ];

  navWithFilters(approvalStatus, scoreClass?) {
    this.ptSvc.loading.set(true);
    let storeStatus;
    const statuses = Object.keys(statusKey);
    statuses.map(status => {
      if (statusKey[status] === approvalStatus) {
        storeStatus = status;
      }
    });
    const sessionFilters = {
      logic: 'and',
      filters: [
        {
          field: this.statusFilter,
          operator: 'contains',
          value: [storeStatus],
        },
      ],
    };

    if (scoreClass) {
      sessionFilters.filters.push({
        field: 'ScoreClass',
        operator: 'contains',
        value: [scoreClass.split('C')[0].toLowerCase()],
      });
    }
    this.ss.set(this.relatedGridName, sessionFilters);

    this.route.navigate([this.navLink]);
  }
}
